<template>
    <div class="modal_richmedia_box">
        <template v-for="(value_richmedia, idx_richmedia) in options.collection">
            <template v-if="idx_richmedia < 1 ">
                <div class="modal_richmedia_box_thumb w-full h-0 bg-dodger_blue absolute block bg-contain bg-no-repeat bg-center shadow-2xl rounded-lg" :style="{
                        top: Math.min(idx_richmedia, 1) * 10 + 'px',
                        left: Math.min(idx_richmedia, 1) * 10 + 'px',
                        paddingBottom: '60%',
                        zIndex: 100 - idx_richmedia,
                        backgroundImage: idx_richmedia === 0 ? 'url(' + (value_richmedia.thumb )  + ')' : '',
                        
                    }">
                   <div class="overlay">
                    <div class="overlay_icon">
                        <span v-if="value_richmedia.type == 'html5video' && value_richmedia.colorIcon == undefined" class="icon-play2"></span>
                       <span v-if="value_richmedia.type == 'html5video' && value_richmedia.colorIcon == 'colorIconBlack'" class="icon-play2  colorIconBlack"></span>
                        <span v-if="value_richmedia.type == 'html5video' && value_richmedia.colorIcon == 'colorIconGrey'" class="icon-play2 colorIconGrey"></span>
                       
                       <span v-if="value_richmedia.type == 'iframe' && value_richmedia.colorIcon == undefined" class="icon-file-pdf"></span>
                       <span v-if="value_richmedia.type == 'iframe' && value_richmedia.colorIcon == 'colorIconBlack'" class="icon-file-pdf colorIconBlack"></span>
                       <span v-if="value_richmedia.type == 'iframe' && value_richmedia.colorIcon == 'colorIconGrey'" class="icon-file-pdf colorIconGrey"></span>

                       <span v-if="value_richmedia.type == 'image'" class="icon-image"></span>
                       <span v-if="value_richmedia.type == 'video'" class="icon-document-file-mp3"></span>

                       <span v-if="value_richmedia.type == 'link' && value_richmedia.colorIcon == undefined" class="icon-link"></span>
                       <span v-if="value_richmedia.type == 'link' && value_richmedia.colorIcon == 'colorIconBlack'" class="icon-link colorIconBlack"></span>
                    </div>
                    </div> 
                </div>
            </template>
        </template>

        <template v-for="(value_richmedia, idx_richmedia) in options.collection">
            <template v-if="idx_richmedia===0">
                <div class="font-medium text-base leading-4 text-grey-900 text-center mt-3 w-full ">
                    <template>
                        {{ options.collection_name || value_richmedia.collection || value_richmedia.type }}
                    </template>
                </div>
            </template>

        </template>
    </div>
</template>
<script>

import RichmediaMixin from "../mixins/RichmediaMixin";

export default {
    name: "ModalRichmediaBox",
    mixins: [RichmediaMixin],
    props: {
        options: {
            collection_name: null,
            collection: null,
            page: null,
        }
    },
}
</script>

<style scoped lang="scss">
.modal_richmedia_box {
    cursor: pointer;
    .modal_richmedia_box_thumb{
        position: relative;
       
        .overlay{
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                opacity: 0;
                transition: all 0.3s ease-in-out;
                background-color: rgba(#000, 0.3);
                 @media screen and (max-width:767px) {
                    opacity: 1;
                    background-color: transparent; 
                    justify-content: end;
                    align-items: end;
                    .positionCenter{
                    justify-content: center;
                    align-items: center;   
                        }
                     }
                .overlay_icon{
                    width: 50px;
                    height: 50px;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                    @media screen and (max-width:767px) {
                        

                        .colorIconWhite{
                            color: #fff;
                        }
                        .colorIconBlack{
                            color:#000;
                        }
                        .colorIconGrey{
                            color: grey;
                        }

                    color: #fff;
                     }
                     span{
                         font-size: 40px;
                     }   
                }
            }
        &:hover {
            .overlay{
                opacity: 1;
            }
        }
    }
    
}
</style>
